module.exports = __webpack_public_path__ + "static/media/MonoThick.ef35f8f9.svg";